import { defineStore } from "pinia";
import axios from "axios";
import { useApplicationStore } from "@/state/pinia";

export const useSignInStore = defineStore("signin", {
    state: () => ({
        currentVIN: JSON.parse(sessionStorage.getItem('waos_rm.signin.currentVIN')),
        vin: "",
        authError: null,
        isAuthError: false
    }),
    getters: {
        signedIn() {
            return !!this.currentVIN
        },
    },
    actions: {
        setLoginError(error, hasError){
            this.isAuthError = hasError;
            this.authError = error ? error : "";
        },
        setUser(vinUser) {
            this.currentVIN = vinUser
            window.sessionStorage.setItem('waos_rm.signin.currentVIN', JSON.stringify(vinUser))
        },
        logOut(){
            this.setUser(null)
        },
        logIn(){
            this.setLoginError(null, false)
            const appStore = useApplicationStore();
            appStore.setLoading(true);
            const postData = new FormData();
            postData.append("vin", this.vin);
            const reqAxios = axios.create({headers: { "Content-Type": "multipart/form-data" }})
            reqAxios.post(process.env.VUE_APP_URL+'api/auth/signin',postData).then((response) => {
                this.setLoginError(null, false)

                if (response.status === 200) {
                    this.setUser(this.vin)
                }
            }).catch(() => {
                this.setLoginError('user.vin.error', true)
            }).finally(()=>{
                appStore.setLoading(false);
            });
        }
    },
})
